import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/ArrowsUpdown.tsx
const ArrowsUpdownIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M18.744 16.119a.875.875 0 1 0-1.238-1.238l-1.131 1.132V6.75a.875.875 0 0 0-1.75 0v9.263l-1.131-1.132a.875.875 0 1 0-1.238 1.238l2.625 2.625a.875.875 0 0 0 1.238 0l2.625-2.625ZM11.744 7.881a.875.875 0 0 1-1.238 1.238L9.375 7.987v9.263a.875.875 0 0 1-1.75 0V7.987L6.494 9.12A.875.875 0 1 1 5.256 7.88l2.625-2.625a.875.875 0 0 1 1.238 0l2.625 2.625Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { ArrowsUpdownIcon };
